var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgArchiveDownloadIconLg = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 29,
  height: 27,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M25.984 6.738v16.211H3.016V6.738H0v19.611h29V6.738h-3.016Z",
  fill: "#C1C4D8"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M17.263 8.117V0h-5.49v8.117h-4.54l7.269 12.668 7.267-12.668h-4.506Z",
  fill: "#C1C4D8"
})));
export { SvgArchiveDownloadIconLg as ReactComponent };
export default __webpack_public_path__ + "b4897c61c1a07e00e401a5cf4cf91e80.svg";